import React from 'react';
import { EnterCredential } from 'new/elements/flows/EnterCredential';
import useReplication from 'new/components/flows/types/replication/useReplication';
import { FCFormPageType } from 'new/elements/Form/useForm';
import { FORM_TYPE_CREATE_REPLICATION } from 'js/constants/formTypes';
import useCredentialsPage from 'new/components/flows/controller/useCredentialsPage';
import { loadDataCredentials, loadFullVendor } from 'js/actions';
import { ACLQueryModeTypes } from 'js/constants/visibilityFilters';
import useAppDispatch from 'js/hooks/useAppDispatch';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import { GET_ALL_CREDENTIALS_REQUEST, GET_FULL_VENDOR_REQUEST } from 'js/constants/actionTypes';

export const EnterCredentialPage: FCFormPageType<any> = () => {
  const { credentialId, selectedConnection, selectedCredentialInfo } = useReplication();
  const dispatch = useAppDispatch();
  const {
    onSaveCredential,
    onChangeTemplate,
    selectedTemplate,
    onEditCredential,
    onCredentialSelected,
    onCredentialInfoUpdated,
  } = useCredentialsPage({
    useFormData: useReplication,
    formType: FORM_TYPE_CREATE_REPLICATION,
  });

  const loadCredentialNeeds = () => {
    dispatch(loadFullVendor(selectedConnection));
    dispatch(loadDataCredentials(ACLQueryModeTypes.MODE_COLLABORATOR.key));
  };

  const areCredentialsLoading = useIsLoading(GET_ALL_CREDENTIALS_REQUEST, GET_FULL_VENDOR_REQUEST);

  return (
    <EnterCredential
      reload={loadCredentialNeeds}
      areCredentialsLoading={areCredentialsLoading}
      credentialId={credentialId}
      onChangeTemplate={onChangeTemplate}
      selectedTemplate={selectedTemplate}
      onCredentialInfoUpdated={onCredentialInfoUpdated}
      onSaveCredential={onSaveCredential}
      onEditCredential={onEditCredential}
      selectedCredentialInfo={selectedCredentialInfo}
      onCredentialSelected={onCredentialSelected}
      connectionType={selectedConnection}
    />
  );
};

EnterCredentialPage.formConfig = {
  title: 'Authenticate',
};
